/**
 * Cinematic scroll interaction for the hero's dog cutout: a subtle
 * upward drift tied to scroll position via ScrollTrigger's `scrub` (no
 * independent RAF loop, no lag/stutter — GSAP reads the same
 * Lenis-driven scroll position already powering the rest of the site's
 * motion). Deliberately animates translateY only (via `yPercent`) — no
 * scale, and no width/height/top/left — so this is a single composited
 * transform the GPU can promote once and reuse every frame instead of
 * re-triggering layout/paint, which is what reads as "glitchy" jitter
 * during scroll.
 *
 * No-ops entirely under prefers-reduced-motion or if GSAP/ScrollTrigger
 * aren't available, leaving the dog in its resting CSS position.
 */
import { motionEnabled } from '@theme/premium-motion';

const hero = document.querySelector('.flv-hero');
const petArea = hero?.querySelector('.flv-hero__pet-area');

if (hero && petArea && motionEnabled && typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
  gsap.to(petArea, {
    yPercent: -8,
    ease: 'none',
    scrollTrigger: {
      trigger: hero,
      start: 'top top',
      end: 'bottom top',
      scrub: 0.6,
    },
  });
}
